const LICENSES_ENTITY = 'licenses';
const ALL_LICENSES_ENTITY = 'allLicenses';
const LICENSES_BY_ID_ENTITY = 'licensesById';
const API_KEYS_ENTITY = 'apiKeys';
const ADMIN_API_KEYS_ENTITY = 'adminKeys';
const STORAGE_OBJECTS_ENTITY = 'storageObjects';
const BATCHES_ENTITY = 'batches';
const JOBS_ENTITY = 'jobs';
const MAIN_JOBS_ENTITY = 'mainJobs';
const RUNNING_JOBS_ENTITY = 'runningJobs';
const QUEUED_JOBS_ENTITY = 'queuedJobs';
const NON_AGGREGATED_JOBS_ENTITY = 'nonAggregatedJobs';
const RECENT_JOBS_ENTITY = 'recentJobs';
const HISTORY_JOBS_ENTITY = 'historyJobs';

export {
  LICENSES_ENTITY,
  ALL_LICENSES_ENTITY,
  LICENSES_BY_ID_ENTITY,
  API_KEYS_ENTITY,
  ADMIN_API_KEYS_ENTITY,
  STORAGE_OBJECTS_ENTITY,
  BATCHES_ENTITY,
  JOBS_ENTITY,
  MAIN_JOBS_ENTITY,
  RUNNING_JOBS_ENTITY,
  QUEUED_JOBS_ENTITY,
  NON_AGGREGATED_JOBS_ENTITY,
  RECENT_JOBS_ENTITY,
  HISTORY_JOBS_ENTITY,
};
